import { Component, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { hideElementById } from '@/util/style-util';

const appStoreState = namespace('appStore');

@Component({})
export default class PopupRequiredLoginComponent extends Vue {
  @appStoreState.Getter
  public getIsShowPopupRequiredLogin!: boolean;

  @appStoreState.Mutation
  public setIsShowPopupRequiredLogin!: (payload: boolean) => void;

  @appStoreState.Mutation
  public setIsShowPopupLogin!: (payload: boolean) => void;

  @appStoreState.Mutation
  public setIsShowPopupRegister!: (payload: boolean) => void;

  handleOpenPopupLogin() {
    this.handleClosePopupRequiredLogin();
    this.setIsShowPopupLogin(true);
  }

  handleClosePopupRequiredLogin() {
    this.setIsShowPopupRequiredLogin(false);

    hideElementById('buttonClosePopupRequiredLogin', true);
  }

  handleOpenPopupRegister() {
    this.handleClosePopupRequiredLogin();
    this.setIsShowPopupRegister(true);
  }

  // logout() {
  //   this.$emit('logout');
  //
  //   const modalElement = document.getElementById('go-modal-logout');
  //
  //   if (modalElement) {
  //     modalElement.style.visibility = 'hidden';
  //   }
  //
  //   const closeButton = document.getElementById('logoutButton');
  //
  //   if (closeButton) {
  //     closeButton.click();
  //   }
  // }
}
